import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { BitacoraService } from '../../../../services/apiService';
import { MultiSelect } from 'primereact/multiselect';
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../../utils/bitacora';
import dayjs from 'dayjs';
import { createRenderCustomHeader } from '../../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../../utils/datePickerUtils';
import '../../../../styles/datepicker.css'

// 📌 Registrar la localización en español para DatePicker 
registerLocale('es', es);
setDefaultLocale('es'); //  

const BitacoraFiltros = ({ onGenerateReport, imprimir }) => {

    const [selectedUsuarios, setSelectedUsuarios] = useState([]);
    const [usuarios, setUsuarios] = useState([]);/*  */

    const [selectedCategorias, setSelectedCategorias] = useState([]);
    const [categorias, setCategorias] = useState([]);

    const [btnFiltroActivo, setBtnActiveFilter] = useState(false);

    // Verificar si la empresa NO es 9 para ocultar categorías
    const empresaId = localStorage.getItem('empresa_id');
    const shouldHideCategories = empresaId !== '9';

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);
    const [dateRangeWarning, setDateRangeWarning] = useState("");
    const [dateRangeInvalid, setDateRangeInvalid] = useState(false);
    // Validar rango de fechas: máximo 5 días
    useEffect(() => {
        if (!startDate || !endDate) return;
        const diffMs = endDate - startDate;
        const diffDays = diffMs / (1000 * 60 * 60 * 24);
        if (diffDays > 30) {
            setDateRangeWarning("El rango máximo permitido es de 30 días.");
            setDateRangeInvalid(true);
            // import('sweetalert2').then(Swal => {
            //     Swal.default.fire({
            //         icon: 'warning',
            //         title: 'Rango de fechas inválido',
            //         text: 'El rango máximo permitido es de 30 días.',
            //     });
            // });
        } else {
            setDateRangeWarning("");
            setDateRangeInvalid(false);
        }
    }, [startDate, endDate]);

    // 🚗 Cargar Vehículos
    const loadUsuarios = async () => {
        try {
            const response = await BitacoraService.getUsuarios();
            if (response && response.statusCode === 200) {
                console.log(response.data);
                const data = response.data.map(usuario => ({
                    value: usuario.uid_usuario,
                    label: `${usuario.nombre} `,
                    /*  uid_grupo: vehiculo.uid_grupo,
                     no_economico: vehiculo.no_economico,
                     alias: `${vehiculo.alias}`, */
                    uid_empresa: usuario.uid_empresa
                }));
                setUsuarios(data);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        }
    };

    // Función para convertir a Pascal Case
    const toPascalCase = (str) => {
        return str.trim()
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // 🚗 Cargar Categorias
    const loadCategorias = async () => {
        try {
            const response = await BitacoraService.getCategoriaBitacoras();
            console.log("Response de categorias:", response);

            // El servicio devuelve response.data directamente, que es el array
            if (response && Array.isArray(response)) {
                const data = response.map((categoria, index) => ({
                    value: categoria, // Usar el nombre como value
                    label: toPascalCase(categoria), // Aplicar Pascal Case al label
                }));
                console.log("Categorias procesadas:", data);
                setCategorias(data);
            }
        } catch (error) {
            console.error("Error cargando categorias:", error);
        }
    };

    useEffect(() => {
        loadUsuarios();
        loadCategorias();
    }, []);

    useEffect(() => {

        if (selectedUsuarios.length > 0) {
            setBtnActiveFilter(true)
        } else {

            setBtnActiveFilter(false)
        }
    }, [selectedUsuarios, selectedCategorias])

    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    const handleGenerate = () => {
        // 🔹 Ajustar fechas a la zona horaria local para que coincidan con la selección del usuario
        const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
        const fecha_inicio = new Date(startDate.getTime() - offset).toISOString(); // Ajustar a UTC
        const fecha_fin = new Date(endDate.getTime() - offset).toISOString(); // Ajustar a UTC
        console.log(selectedUsuarios);
        generarBitacoraReporte(AccionBitacora.Generar);
        onGenerateReport({
            fecha_inicio: fecha_inicio,
            fecha_fin: fecha_fin,
            //uids_usuario: selectedUsuarios && selectedUsuarios.length > 0 ? selectedUsuarios.map(v => v.value) : [],
            uids_usuario: selectedUsuarios && selectedUsuarios.length > 0 ? selectedUsuarios : [],
            categorias: selectedCategorias && selectedCategorias.length > 0 ? selectedCategorias.map(cat => cat.value || cat) : [],
        });
    };


    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Bitacora', observacion: 'Bitacora', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = [];
            let dataVehiculos = [];
            let dataAlertas = [];
            let dataUsuarios = (usuarios || []).filter(w => (selectedUsuarios || []).includes(w.value))
            let dataCategorias = (categorias || []).filter(w => (selectedCategorias || []).some(sel => sel.value === w.value || sel === w.value))
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas, dataUsuarios, dataCategorias };
        }
        guardarBitacora({
            categoria: 'Reporte Bitacora',
            observacion: generarObservacion(
                'Bitacora',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                    usuarios: filtrosGenerarRef.current.dataUsuarios.map(w => w.label).join(', '),
                    categorias: filtrosGenerarRef.current.dataCategorias.map(w => w.label).join(', ')
                }
            ),
            tipoAccion: accion
        });
    }
    // 📌 Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {

        const allSelected = selected.some(option => option.value === 'all');

        const todasLasOpciones = options.flatMap(usr => usr.options || usr);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) { // 🔹 Se suma 1 por la opción "Seleccionar todos"
                setSelected([]); // 🔹 Deseleccionar todo correctamente
            } else {
                setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
            }
        } else {
            setSelected(selected);
        }
    };

    // 📌 Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);
    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );

    return (
        <div>
            <div id="filter-collapse">
                <Row>

                    {dateRangeWarning && (
                        <Col xs={12}>
                            <div className="alert alert-warning py-2 my-2">
                                {dateRangeWarning}
                            </div>
                        </Col>
                    )}
                    <Col md={3} xs={4}>



                        <Form.Group>
                            <Form.Label>Desde</Form.Label>
                            <DatePicker
                                selected={startDate}
                                onChange={handleStartDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderIniHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es"
                                timeCaption="Hora"
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3} xs={4}>
                        <Form.Group>
                            <Form.Label>Hasta</Form.Label>
                            <DatePicker
                                selected={endDate}
                                minDate={startDate}
                                minTime={
                                    endDate.getDate() === startDate.getDate()
                                        ? startDate
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                                }
                                maxTime={
                                    endDate.getDate() === new Date().getDate() &&
                                        endDate.getMonth() === new Date().getMonth() &&
                                        endDate.getFullYear() === new Date().getFullYear()
                                        ? new Date() // hasta la hora actual si es hoy
                                        : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59) // hasta fin del día
                                }
                                onChange={handleEndDateChangeWrapper}
                                customInput={<ExampleCustomInput />}
                                timeIntervals={5}
                                dateFormat="dd/MM/yyyy HH:mm:ss"
                                /* showTimeSelect */
                                renderCustomHeader={renderEndHeader}
                                popperClassName="custom-datepicker-popper"
                                fixedHeight
                                locale="es" // 📌 Localización en español
                                timeCaption="Hora" // 
                                maxDate={new Date()}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={3} xs={4} className="d-flex flex-column">
                        <Form.Group>
                            <Form.Label>Usuarios</Form.Label>
                            <MultiSelect
                                className=" w-full md:w-20rem"
                                value={selectedUsuarios || []}
                                onChange={(e) => {
                                    setSelectedUsuarios(e.value);
                                }}
                                options={usuarios}
                                optionLabel="label"
                                filter
                                placeholder="Seleccione un usuario"
                                highlightOnSelect={false}
                                styles={customStyles}
                                maxSelectedLabels={2}
                                selectedItemsLabel={`${(selectedUsuarios || []).length} usuarios seleccionados`}
                            />
                        </Form.Group>
                    </Col>
                    {!shouldHideCategories && (
                        <Col md={3} xs={4} className="d-flex flex-column">
                            <Form.Group>
                                <Form.Label>Categorias</Form.Label>
                                <MultiSelect
                                    className=" w-full md:w-20rem"
                                    value={selectedCategorias || []}
                                    onChange={(e) => {
                                        setSelectedCategorias(e.value);
                                    }}
                                    options={categorias}
                                    optionLabel="label"
                                    filter
                                    placeholder="Seleccione una categoria"
                                    highlightOnSelect={false}
                                    styles={customStyles}
                                    maxSelectedLabels={2}
                                    selectedItemsLabel={`${(selectedCategorias || []).length} categorias seleccionadas`}
                                />
                            </Form.Group>
                        </Col>
                    )}
                    <Col md={2} xs={4}>
                        <div className="d-flex mt-4">
                            <Button variant="primary" className="w-100" onClick={handleGenerate} disabled={!btnFiltroActivo || dateRangeInvalid}>
                                Generar
                            </Button>
                            {/* {dateRangeWarning && (
                                <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>{dateRangeWarning}</div>
                            )} */}
                        </div>
                    </Col>
                    <Col md={2} xs={4}>
                        <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                        </div>
                    </Col>
                </Row>
            </div>
            {/* </Collapse> */}
        </div>
    );
};

export default BitacoraFiltros;